import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cartPlus",
  "use": "icon-cartPlus-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cartPlus\">\n<rect width=\"32\" height=\"32\" rx=\"4\" fill=\"currentColor\" />\n<path d=\"M17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8V15H8C7.44772 15 7 15.4477 7 16C7 16.5523 7.44772 17 8 17H15V24C15 24.5523 15.4477 25 16 25C16.5523 25 17 24.5523 17 24V17H24C24.5523 17 25 16.5523 25 16C25 15.4477 24.5523 15 24 15H17V8Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol